module.exports = {
  name: 'production',
  vaultId: 'tntenbo0eyj',
  environment: 'live',
  endpoint: 'vgs-live.sitecore.moweb-acc.com',
}